import {getItem} from './getItem';
import {setItem} from './setItem';

export const storageService: StorageService = {
  getItem,
  setItem,
};
